// extracted by mini-css-extract-plugin
export default {"window":"window_question_window__B+FIE","trigger_window":"window_question_trigger_window__lGbeg","message":"window_question_message__+gcDi"};